import type { ActivityResponse } from '@stream-io/feeds-client'

import { ValkTalkPost, ValkTalkPostFormData } from './ValkTalkPost'
import { getFeedTypeFromFids } from './ValkTalkPostHelpers'

export const transformActivityToValkTalkPost = (activity: ActivityResponse): ValkTalkPost | undefined => {
    const feedType = getFeedTypeFromFids(activity.feeds)

    if (! feedType) {
        return undefined
    }

    const imageUrls = activity.attachments
        .filter(attachment => attachment.type === 'image')
        .map(attachment => attachment.image_url ?? attachment.asset_url)
        .filter((url): url is string => Boolean(url))

    return {
        id: activity.id,
        feedType,
        title: activity.custom?.title ?? '',
        text: activity.text ?? '',
        images: imageUrls.map(url => ({ id: url, url })),
        author: {
            id: activity.user.id,
            name: activity.user.name,
        },
        createdAt: new Date(activity.created_at),
    }
}

// The multipart body of Valkplanner's feed messages endpoint, which picks the feed and post type from `feed_type`
export const transformValkTalkPostFormDataToFeedMessageFormData = (formData: ValkTalkPostFormData): FormData => {
    const body = new FormData()

    body.append('feed_type', formData.feedType)
    body.append('title', formData.title.trim())
    body.append('text', formData.text.trim())

    formData.images.forEach(image => {
        if (image.file) {
            body.append('images[]', image.file)
        }
    })

    return body
}

// The multipart body for updating a feed message. The feed can't be changed, so there's no `feed_type`. Every image is
// sent at its display index: existing images as their Stream url, new images as a file.
export const transformValkTalkPostFormDataToUpdateFeedMessageFormData = (formData: ValkTalkPostFormData): FormData => {
    const body = new FormData()

    body.append('title', formData.title.trim())
    body.append('text', formData.text.trim())

    formData.images.forEach((image, index) => {
        body.append(`images[${index}]`, image.file ?? image.url)
    })

    return body
}
